import { render, staticRenderFns } from "./PaidTraining.vue?vue&type=template&id=6a0ac6bd&scoped=true&"
import script from "./PaidTraining.vue?vue&type=script&lang=js&"
export * from "./PaidTraining.vue?vue&type=script&lang=js&"
import style0 from "./PaidTraining.vue?vue&type=style&index=0&id=6a0ac6bd&lang=scss&scoped=true&"
import style1 from "./PaidTraining.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0ac6bd",
  null
  
)

export default component.exports